import { useContext, useEffect, useState } from "react";
import "./hero.css";
import { AuthContext } from "../util/api";

const slides = [
  {
    title: "Integrated Digital Healthcare",
    highlight: "Secure • Accessible • Global",
    text: "A connected healthcare ecosystem providing trusted medical advice, pharmaceutical access, and large-scale public health solutions across communities.",
    services: [
      {
        icon: "💊",
        title: "Medical Advice & Treatment",
        desc: "Access expert health guidance with secure medical records that follow you globally.",
        link: "https://doc.centernut.com/",
      },
      {
        icon: "🏥",
        title: "Pharmaceutical Access & Safety",
        desc: "Verified medications directly from trusted pharmaceutical companies.",
        link: "https://pharmacy.centernut.com/",
      },
      {
        icon: "🌍",
        title: "Community Medicine & Public Health",
        desc: "Large-scale health campaigns and preventive care awareness.",
        link: "https://doc.centernut.com/",
      },
    ],
  },
  {
    title: "Business & Marketplace Innovation",
    highlight: "Entrepreneurship • Growth • Opportunity",
    text: "Empowering businesses and entrepreneurs with tools, campaigns, mentorship, and a transparent digital marketplace.",
    services: [
      {
        icon: "🛒",
        title: "Marketplace",
        desc: "Seamlessly connect buyers and sellers in a transparent win–win ecosystem.",
        link: "https://business.centernut.com/",
      },
      {
        icon: "💼",
        title: "Business & Entrepreneurship Support",
        desc: "Expert mentorship and resources for startups and businesses to thrive.",
        link: "https://business.centernut.com/",
      },
      {
        icon: "🚀",
        title: "Startup Campaigns & Webinars",
        desc: "Launch campaigns, showcase innovations and host live webinars.",
        link: "https://business.centernut.com/",
      },
    ],
  },
  {
    title: "Education, Research & Skills",
    highlight: "Knowledge • Innovation • Impact",
    text: "Building intellectual capital through virtual education, global research access, scholarships, and professional skill development.",
    services: [
      {
        icon: "🎓",
        title: "Virtual Education & Scholarships",
        desc: "E-learning support and global scholarship opportunities.",
        link: "https://business.centernut.com/",
      },
      {
        icon: "📚",
        title: "Research & Publishing",
        desc: "Access global journals and publish academic research.",
        link: "https://business.centernut.com/",
      },
      {
        icon: "🧠",
        title: "Skill Development & Learning",
        desc: "Acquire new skills from verified experts worldwide.",
        link: "https://business.centernut.com/",
      },
    ],
  },
];

export default function Hero() {
  const [index, setIndex] = useState(0);
  const { theme } = useContext(AuthContext);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  const slide = slides[index];

  return (
    <div style={{marginTop: "80px"}} className={theme}>
      <section className="hero-wrap" id="home">
        <section className="hero">
          <div className="hero-text">
            <h1>
              {slide.title}
              <span>{slide.highlight}</span>
            </h1>

            <p>{slide.text}</p>

            <div className="hero-actions">
              <button className="btn-primary">Explore Platform</button>
              <button className="btn-outline">Learn More</button>
            </div>
          </div>

          <div className="hero-services">
            {slide.services.map((service, i) => (
              <a
                key={i}
                href={service.link}
                target="_blank"
                rel="noopener noreferrer"
                className="service-card"
              >
                <div className="service-icon">{service.icon}</div>
                <h4>{service.title}</h4>
                <p>{service.desc}</p>
              </a>
            ))}
          </div>
        </section>

        <div className="hero-divider">
          <span></span>
        </div>
      </section>
    </div>
  );
}